<div class="grid p-fluid">
  <form [formGroup]="resultForm" class="col-12 lg:col-12 md:col-12 form-group" novalidate>
    <div class="p-fluid p-formgrid grid">
      <div class="col-12 md:col-4 lg:col-4 nopad">
        <p-fieldset class="p-field nopad" legend="{{'Cf_Infos' | translate}}">
          <span class="p-float-label size_cent">
            <input formControlName="grpname" class="p-inputtext size_cent" pInputText type="text" />
            <label>{{'Cf_GrpName' | translate}} *</label>
          </span>
          <span class="p-float-label size_cent form-margin">
            <input formControlName="gr_label" class="p-inputtext size_cent" pInputText type="text" />
            <label>{{'Label' | translate}}</label>
          </span>
          <span class="p-float-label size_cent form-margin">
            <div>{{'Cf_Desc' | translate}}</div>
            <textarea formControlName="desc" rows="4" cols="57" pInputTextarea></textarea>
          </span>
        </p-fieldset>
      </div>
      <p-fieldset class="p-field col-12 md:col-4 lg:col-4 nopad" legend="{{'Cf_Usern' | translate}}">
        <p-listbox
          formControlName="userList"
          [options]="userListBase"
          multiple="multiple"
          checkbox="checkbox"
          [style]="{ width: '100%' }"
          [listStyle]="{ width: '100%', height: '35vh' }"
          scrollHeight="35vh"
          >
        </p-listbox>
      </p-fieldset>
    </div>
  </form>
</div>

<div class="col-12 lg:col-12 md:col-12 align-right">
  @if (dataItem) {    
    @if (dataItem.duplicate === false) {
      <button
        (click)="deleteItem()"
        class="p-button-danger p-button p-component p-button-text-only blockBottom margin"
        >
        {{'Delete' | translate}}
      </button>
    }
  }
  <button
    (click)="cancel()"
    type="button"
    class="p-button p-button-primary p-button-outlined p-component p-button-text-only btn-square margin"
    >
    {{'Cancel' | translate}}
  </button>
  <button
    (click)="validate()"
    type="button"
    class="p-button p-component p-button-text-only btn-square margin"
    >
    {{'Valid' | translate}}
  </button>
</div>
